import React from 'react';

const KPIMapCard = (props) => {
  return (
    <div className="col-lg-2 col-md-4 col-6 kpi-col">
      <div
        className="kpi-card h-100"
        style={props.color ? { backgroundColor: props.color } : undefined}
      >
        <div className="kpi-card__body">
          <div className="kpi-card__value">{props.kpi}</div>
          <div className="kpi-card__label">{props.desc}</div>
        </div>
      </div>
    </div>
  );
};

export default KPIMapCard;
